@if (hasData) {
  <svg viewBox="0 0 300 130" xmlns="http://www.w3.org/2000/svg" data-testid="fermenter-bf-chart">
    @if (fgY !== null) {
      <line x1="8" [attr.y1]="fgY" x2="292" [attr.y2]="fgY"
        stroke="#2dd36f" stroke-width="1" stroke-dasharray="4 3"/>
      <text x="292" [attr.y]="fgY - 3" text-anchor="end" font-size="8" fill="#2dd36f">FG {{ fgLabel }}</text>
    }
    @if (tempPoints) {
      <polyline [attr.points]="tempPoints" fill="none" stroke="#4c8dff" stroke-width="1" opacity="0.55"/>
    }
    <polyline [attr.points]="sgPoints" fill="none" stroke="#d97706" stroke-width="2"
      stroke-linejoin="round" stroke-linecap="round"/>
    <circle [attr.cx]="lastX" [attr.cy]="lastY" r="2.5" fill="#d97706"/>

    @if (ogLabel) {
      <text x="8" y="10" font-size="8" fill="#92949c">OG {{ ogLabel }}</text>
    }
    <text x="292" y="10" text-anchor="end" font-size="8" fill="#d97706">SG {{ sgLabel }}</text>
    <text x="8" y="127" font-size="8" fill="#92949c">{{ startLabel }}</text>
    <text x="292" y="127" text-anchor="end" font-size="8" fill="#92949c">{{ endLabel }}</text>
  </svg>
}
